import { GlobalStateDispatch } from "../state/GlobalStateProvider";

export const handleError = (e: Error, globalDispatch: GlobalStateDispatch) =>
{
    globalDispatch({
        type: "setError",
        payload: e
    });
};

export const ensureSuccess = async (r: Response): Promise<Response> =>
{
    if (r.ok)
    {
        return r;
    }
    else if (r.status === 401)
    {
        if (!window.location.pathname.startsWith("/.auth/login/aad?post_login_redirect_uri"))
        {
            window.location.href = `/.auth/login/aad?post_login_redirect_uri=${window.location.pathname}`;
        }
        throw new Error(`HttpError ${r.status} - ${r.statusText}: ${await r.text()}`);
    }
    else
    {
        throw new Error(`HttpError ${r.status} - ${r.statusText}: ${await r.text()}`);
    }
}